import lightTheme from '../components/style/lightTheme';

const MuiAlert = {
  styleOverrides: {
    root: {
      '&.MuiAlert-filledDefault': {
        backgroundColor: lightTheme.snackbarDefaultFill,
      },
      '&.MuiAlert-filledInfo': {
        backgroundColor: lightTheme.sysInfoDefault,
      },
      '&.MuiAlert-filledSuccess': {
        backgroundColor: lightTheme.sysSuccessDefault,
      },
      '&.MuiAlert-filledWarning': {
        backgroundColor: lightTheme.sysWarningDefault,
      },
      '&.MuiAlert-filledError': {
        backgroundColor: lightTheme.sysDangerDefault,
      },
      '&.MuiAlert-outlinedError': {
        borderColor: lightTheme.dangerBorder,
      },
      '&.MuiAlert-outlinedError .MuiAlert-message': {
        color: lightTheme.alertErrorContent,
      },
      '&.MuiAlert-outlinedError .MuiAlertTitle-root': {
        color: lightTheme.alertErrorContent,
      },
      '&.MuiAlert-outlinedError .MuiAlert-icon': {
        color: lightTheme.dangerIcon,
      },
    },
  },
};

export default MuiAlert;
